'use client'

import { motion } from 'framer-motion'
import { trackEvent } from '@/lib/utils'

export function FloatingCTAButton() {
  return (
    <motion.div
      initial={{ opacity: 0, scale: 0.8, y: 20 }}
      animate={{ opacity: 1, scale: 1, y: 0 }}
      transition={{ duration: 0.5, delay: 1 }}
      style={{ position: 'fixed', bottom: '1rem', right: '1rem', zIndex: 50 }}
    >
      <button
        className="p-[4px] relative"
        data-cal-namespace="work-with-me"
        data-cal-link="mohammed-saket-d4virq/work-with-me"
        data-cal-config='{"layout":"month_view"}'
        onClick={() => {
          trackEvent('book_button_clicked', {
            event_category: 'engagement',
            event_label: 'floating_cta',
            value: 1,
          })
        }}
      >
        <div className="absolute inset-0 bg-gradient-to-r from-indigo-500 to-purple-500 rounded-full" />
        <div className="px-6 py-3 bg-black rounded-full relative group transition duration-200 text-white hover:bg-transparent font-semibold text-lg flex items-center gap-3">
          <svg
            className="w-6 h-6"
            fill="none"
            stroke="currentColor"
            viewBox="0 0 24 24"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={2}
              d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z"
            />
          </svg>
          <span>Work with me</span>
        </div>
      </button>
    </motion.div>
  )
}

